<script>
  import ScoreFiltersLegendItem from './score-filters-legend-item/score-filters-legend-item.svelte';
</script>

<style>
</style>

<template lang="pug" src="./score-filters-legend.pug"></template>
